/**
 * @description Shared spinner/loading indicator component
 *
 * Key features:
 * - SVG-based spinner with smooth CSS animation
 * - Three size presets: sm (16px), md (24px), lg (32px)
 * - Inherits text color from parent for easy theming
 * - Minimal markup — drop-in replacement for inline spinner SVGs
 *
 * @notes
 * - Used in button loading states, modal actions, and inline indicators
 * - For full-page loading states, use the border-based spinner pattern instead
 */

function Spinner({ size = 'sm', className = '' }) {
  const sizeClass = size === 'sm' ? 'h-4 w-4' : size === 'md' ? 'h-6 w-6' : 'h-8 w-8';

  return (
    <svg
      className={`animate-spin ${sizeClass} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
  );
}

export default Spinner;
